export default "__VITE_ASSET__FzZiQ_gM__"